import React from 'react';
import EcoClass112023 from 'views/EcoClass112023';

const AccountGeneralPage = () => {
  return <EcoClass112023/>;
};

export default AccountGeneralPage;
